export default {
  bulkPolicyUpload: process.env.REACT_APP_FEATURE_BULK_POLICY_UPLOAD // only available in gcp deployments
};
